import type {UpmPlant} from '../types'

import {useUpmPlantsContext} from './useUpmPlantsContext'

interface UseUpmPlantWithRaiseErrorParams {
  plantId: string
  shouldRaiseError?: true
}

interface UseUpmPlantWithoutRaiseErrorParams {
  plantId: string
  shouldRaiseError?: false
}

interface UseUpmPlantParams {
  plantId: string
  shouldRaiseError?: boolean
}

export function useUpmPlant({plantId, shouldRaiseError}: UseUpmPlantWithRaiseErrorParams): UpmPlant
export function useUpmPlant({
  plantId,
  shouldRaiseError
}: UseUpmPlantWithoutRaiseErrorParams): UpmPlant | undefined
export function useUpmPlant({
  plantId,
  shouldRaiseError = true
}: UseUpmPlantParams): UpmPlant | undefined {
  const upmPlants = useUpmPlantsContext()
  const upmPlant = upmPlants[plantId] as UpmPlant | undefined

  if (upmPlant === undefined && shouldRaiseError) {
    throw new Error(`useUpmPlant: No upm plant data found for plant ${plantId}`)
  }

  return upmPlant
}
